module.exports = function passthrough(html) {
  return html
}
module.exports.default = module.exports
module.exports.defaults = { allowedAttributes: {}, allowedTags: [] }
